"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useComparisonEffect = useComparisonEffect;
const react_1 = require("react");
// Implementation is simplified from https://github.com/kentcdodds/use-deep-compare-effect
function useDeepCompareMemoize(value, comparator) {
    const ref = (0, react_1.useRef)(value);
    const mismatch = value.find((a, index) => !comparator(a, ref.current[index]));
    if (mismatch !== undefined) {
        ref.current = value;
    }
    return ref.current;
}
/**
 * A modified version of useEffect, that allows for customising the comparison function executed
 * for the dependencies
 *
 * @param callback to trigger when the comparison returns false for any of the dependencies
 * @param dependencies dependencies to track
 * @param comparator comparator to execute to compare the old dependency against the new
 */
function useComparisonEffect(callback, dependencies, comparator) {
    (0, react_1.useEffect)(callback, useDeepCompareMemoize(dependencies, comparator));
}
//# sourceMappingURL=use_comparison_effect.js.map